import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { startUrl } from "../App";

const AdminProtectedRoute = () => {
  let authObj = null;
  try {
    const authStr = localStorage.getItem("auth");
    if (authStr && authStr !== "true") {
      authObj = JSON.parse(authStr);
    } else if (authStr === "true") {
      // Legacy fallback
      authObj = { role: "admin" }; // Assume admin if legacy true was set
    }
  } catch (e) {
    console.error("Failed to parse auth", e);
  }

  if (!authObj || authObj.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
